import React from "react";
import ReactDOM from "react-dom";

import "whatwg-fetch"; // Import this so Cypress falls back to using XMLHttpRequest when we delete window.fetch
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

import * as serviceWorker from "./serviceWorker";
import App from "./App";

Sentry.init({
  dsn:
    "https://f5e1141956f04c0284543ea6b7d5d4e7@o88276.ingest.sentry.io/192217",
  release: `agility-connect-frontend@${process.env.REACT_APP_VERSION}`,
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 0.1,
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
